// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".isDragging[data-v-2fc82866]{opacity:.4}", ""]);
// Exports
module.exports = exports;
